
export default {
  methods: {
    screenTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },

    goToOtp() {
      this.$router.push({ path: '/sms' })
      this.screenTop()
    },
    gotoVoice() {
      this.$router.push({ path: '/voice' })
      this.screenTop()
    },
    gotoEmail() {
      this.$router.push({ path: '/email' })
      this.screenTop()
    },
    goToMarket() {
      this.$router.push({ path: '/market' })
    },
    goToVoice() {
      this.$router.push({ path: '/voice' })
      this.screenTop()
    },

    goToNumber() {
      this.$router.push({ path: '/phoneCheck' })
      this.screenTop()
    },
    goToWhatsApp() {
      window.open("https://docs-yoni-tech.readme.io/reference/whatsapp_message-send")
    },
    goToAbout() {
      this.$router.push({ path: '/about' })
      this.screenTop()
    },
    gotoTerm() {
      this.$router.push({ path: '/termsService' })
      this.screenTop()
    },
    gotoPrivacyPolicy() {
      this.$router.push({ path: '/privacyPolicy' })
      this.screenTop()
    },
    gotoEsim() {
      window.localStorage.setItem("esim", "true")
      this.$router.push({ path: '/esim' })
      this.screenTop()
    }
  },
}
